
























































import {Component, Prop, Vue} from "vue-property-decorator";
import VueError from "@/components/VueError.vue";
import Success from "@/components/Success.vue";
import ConfirmedAction from "@/components/ConfirmedAction.vue";
import {ApiKey, AwsIoTMQTTAccessDetails} from "@/types/core";
import {CoreClient, curCoreClient, HttpReply} from "@/services/CoreClient";
import MqttCertRow from "@/components/access/MqttCertRow.vue";
import {saveAs} from "file-saver";
import * as _ from "lodash";
import Spinner from "@/components/Spinner.vue";

@Component({
  components: {
    Spinner,
    VueError,
    Success,
    ConfirmedAction,
    MqttCertRow
  },
})
export default class MqttManagementApiKey extends Vue {

  @Prop({ default: {},  type: Object}) apiKey!: ApiKey;

  error:string = '';
  success:string = '';

  certProgress:boolean = false;
  status:'list-all'|'new-created'|'delete-cert' = 'list-all';

  private newCert:AwsIoTMQTTAccessDetails & HttpReply = {
    certArn: '',
    certPem: '',
    certPrivateKey: '',
    certCreatedAt: 0,
    awsRootCAUrl: '',
  };
  private coreClient:CoreClient = curCoreClient;


  maskApiKey(apiKey:string):string {
    return apiKey.substring(0, 10) + "*****" + apiKey.substring(30);
  }

  setSuccess(str:string) {
    this.success = str;
    setTimeout(() => this.$emit('cancel'), 1000);
  }

  async createMQTTCert() {
    this.error = '';
    this.certProgress = true;
    this.newCert = await this.coreClient.createMQTTCert(this.apiKey.apiKey);
    this.certProgress = false;
    if ( this.newCert.errorMsg ) {
      this.error = this.newCert.errorMsg;
      return;
    }
    this.status = 'new-created';
    if (!this.apiKey.mqttCerts) {
      this.apiKey.mqttCerts = [];
    }
    this.apiKey.mqttCerts.push({
      certId: this.getCertId(this.newCert),
      active: true,
      createdAt: this.newCert.certCreatedAt,
    });
  }

  private downloadCert() {
    const blob = new Blob([this.newCert.certPem], {type: 'text/plain;charset=utf-8'});
    saveAs(blob, this.getCertFileName(this.getCertId(this.newCert)));
  }

  private downloadPrivateKey() {
    const blob = new Blob([this.newCert.certPrivateKey], {type: 'text/plain;charset=utf-8'});
    saveAs(blob, this.getCertPKFileName(this.getCertId(this.newCert)));
  }

  private async downloadCA() {
    const caPEM = await this.coreClient.getMqttCA();
    const blob = new Blob([caPEM.pem], {type: 'text/plain;charset=utf-8'});
    saveAs(blob, this.getCAFileName());
  }

  private getCertFileName(certId:string):string {
    return `${certId}-cert.pem`;
  }

  private getCertPKFileName(certId:string):string {
    return `${certId}-private-key.pem`;
  }

  private getCAFileName():string {
    return `neura-iot-ca.pem`;
  }

  private getCmd():string {
    return `mosquitto_sub -h mqtt.${process.env.VUE_APP_DOMAIN_NAME} -p 8883 --key ${this.getCertPKFileName(this.getCertId(this.newCert))} --cert ${this.getCertFileName(this.getCertId(this.newCert))} --cafile ${this.getCAFileName()} -t n-hub/groups/${this.apiKey.groupIdList[0]}/+/+ -d -i client-${this.getCertId(this.newCert)}`;
  }

  private copyMosquittoCmd(cmd:string) {
    navigator.clipboard.writeText(cmd);
  }

  private getCertId(newCert:AwsIoTMQTTAccessDetails):string {
    return newCert.certArn.split('/')[1];
  }

  private deleteMqttCert(certId: string) {
    const index = _.findIndex(this.apiKey.mqttCerts, (cert) => {
      return cert.certId === certId;
    });
    this.apiKey.mqttCerts.splice(index, 1);
  }

  private cancel() {
    this.$emit('cancel');
  }

  get limitReached():boolean {
    return this.apiKey.mqttCerts && this.apiKey.mqttCerts.length >= 5;
  }

  cancelToMQTTList() {
    this.status = 'list-all';
    this.newCert = {
      certArn: '',
      certPem: '',
      certPrivateKey: '',
      certCreatedAt: 0,
      awsRootCAUrl: '',
    };
  }
}
